// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2SSDWf","contentContainer":"_1p1CG3","headerContainer":"lYtugb","breadcrumbs":"_267x1P"};